import { SquarePen, X } from 'lucide-react'
import { useTranslation } from '@/i18n'
import { IntuiButton } from '@/components/intueri/IntuiButton'

/**
 * Card header, to Putra's design (2026-10-16 update): the title, a new-chat
 * control and close. No mark of any kind in here — the launcher in the page
 * header carries the avatar and the empty state below leads with it, so a
 * third copy in this strip would say nothing the other two do not.
 *
 * "New chat" drops the thread and returns to the suggestions; it is the only
 * way to start over short of rating the answer, which is why the design
 * gives it a spot next to Close.
 */
const HelpAgentHeader = ({
  onNewChat,
  onClose,
}: {
  onNewChat: () => void
  onClose: () => void
}) => {
  const { t } = useTranslation('help_agent')
  const iconButton = 'shrink-0 rounded-full text-gray-900 dark:text-dark-text'
  return (
    <div className="flex items-center gap-2 border-b border-gray-100 px-4 py-3 dark:border-dark-border">
      <div className="min-w-0 flex-1 truncate text-base font-medium text-gray-900 dark:text-dark-text">
        {t('header.name')}
      </div>
      <IntuiButton
        variant="ghost"
        size="icon-sm"
        aria-label={t('header.new_chat')}
        onClick={onNewChat}
        className={iconButton}
      >
        <SquarePen />
      </IntuiButton>
      <IntuiButton
        variant="ghost"
        size="icon-sm"
        aria-label={t('header.close')}
        onClick={onClose}
        className={iconButton}
      >
        <X />
      </IntuiButton>
    </div>
  )
}

export default HelpAgentHeader
